module.exports = __webpack_public_path__ + "img/logo_mmcm.bc9bd196.png";